import * as yup from 'yup';

export default function detailsString(key, field, yesNo) {
  return yup.string().nullable().when(key, { is: yesNo, then: field });
}
